/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Professional_InfoInputs */

const en_candidate_profile_professional_info = /** @type {(inputs: Candidate_Profile_Professional_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professional Information`)
};

const de_candidate_profile_professional_info = /** @type {(inputs: Candidate_Profile_Professional_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berufliche Informationen`)
};

/**
* | output |
* | --- |
* | "Professional Information" |
*
* @param {Candidate_Profile_Professional_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_professional_info = /** @type {((inputs?: Candidate_Profile_Professional_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Professional_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_professional_info(inputs)
	return en_candidate_profile_professional_info(inputs)
});